var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewWorkplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4631 0C7.36328 0 4.84155 2.19231 4.84155 4.8871C4.84155 7.58183 7.36333 9.77419 10.4631 9.77419C13.5628 9.77419 16.0846 7.58179 16.0846 4.8871C16.0846 2.19231 13.5629 0 10.4631 0Z",
    fill: "#118F84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4348 10.9512V12.1305V13.3152V18.2739C12.4348 18.4106 12.4045 18.5413 12.3514 18.6633C12.1542 19.1166 11.6244 19.4421 11 19.4421C10.3756 19.4421 9.84591 19.1166 9.64867 18.6633C9.5956 18.5413 9.56525 18.4106 9.56525 18.2739V13.3152V12.1305V10.9512C4.17525 11.5254 0 15.2888 0 19.8316C0 20.4766 0.642395 20.9998 1.43477 20.9998H20.5652C21.3576 20.9998 22 20.4766 22 19.8316C22.0001 15.2889 17.8248 11.5255 12.4348 10.9512Z",
    fill: "#118F84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWorkplace);
export default __webpack_public_path__ + "static/media/NEW_WORKPLACE.0735d3d913b395b14b70617ab9629ba8.svg";
export { ForwardRef as ReactComponent };